// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
// Parts
import Table, { TableApiParamsType, ToolbarType, TableHashCacheType } from "../components/Table";
// Engine
import { axiosAPI } from "../../engine/config/axios";

const Employee:FC<TableHashCacheType & { toolbar: ToolbarType }> = (props) => {
  const { toolbar, hashCache } = props;
  const params = new URLSearchParams(window.location.search);

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      user_type_id: params.get('user_type_id'),
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  const gridParams = {
    grids: [{ name: 'employee', hashCache }],
  }

  return <Table
    toolbar={toolbar}
    api={axiosAPI.employee.table}
    apiParams={apiParams}
    gridName="employee"
    gridParams={gridParams}
    sortingMode="multiple"
  />;
}

function EmployeePortal({ id }: { id: string }) {
  const { t } = useTranslation();
  const Root = document.getElementById(id);
  const toolbar = [{
    name: 'user_type_id',
    type: 'select',
    placeholder: t('Show'),
    values: Root?.dataset?.toolbar_user_type_id || ''
  }];

  return Root ? createPortal(<Employee hashCache={Root?.dataset.hashCache} toolbar={toolbar} />, Root) : null;
}

export default EmployeePortal;
